import { excludeForwardProps } from '@gasbi/shared/common/utils/excludeForwardProps';

import { Typography, styled } from '@mui/joy';
import { TypographyProps } from '@mui/joy/Typography';

interface BaseTypographyProps extends TypographyProps {
  lightColor?: string;
  darkColor?: string;
}

export const BaseTypography = styled(Typography, {
  shouldForwardProp: excludeForwardProps(['lightColor', 'darkColor']),
})<BaseTypographyProps>(({ theme, lightColor, darkColor }) => ({
  color: theme.palette.isDarkMode
    ? (darkColor ?? theme.palette.neutral[600])
    : (lightColor ?? theme.palette.neutral[700]),
}));
